import { csrfToken } from '@/js/_common';
import { showConfirmModal } from '@/js/_components/parts/confirm-modal';

const PICKUP_COUNT_URL = '/admin/magazine/pickup-count';

const setMenuAction = () => {
    const root = document.querySelector('[data-admin-magazine-submenu]');
    if (!root) return;

    const toggleButton = root.querySelector('[data-action="toggle-menu"]');
    const menu = root.querySelector('[data-role="menu"]');
    const pickupForm = document.querySelector('[data-admin-magazine-pickup-form]');
    const unpickupForm = document.querySelector('[data-admin-magazine-unpickup-form]');
    const draftForm = document.querySelector('[data-admin-magazine-draft-form]');
    const deleteForm = document.querySelector('[data-admin-magazine-delete-form]');
    if (!toggleButton || !menu || !pickupForm || !unpickupForm || !draftForm || !deleteForm) return;

    const closeMenu = () => {
        root.dataset.open = 'false';
        root.classList.remove('is-open');
        toggleButton.setAttribute('aria-expanded', 'false');
    };

    const openMenu = () => {
        root.dataset.open = 'true';
        root.classList.add('is-open');
        toggleButton.setAttribute('aria-expanded', 'true');
    };

    closeMenu();

    toggleButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!root.classList.contains('is-open')) {
            openMenu();
            return;
        }
        closeMenu();
    });

    document.addEventListener('click', (e) => {
        if (!root.contains(e.target)) {
            closeMenu();
        }
    });

    menu.querySelector('[data-action="edit"]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        closeMenu();
        const url = e.currentTarget.dataset.editUrl;
        if (url) {
            location.href = url;
        }
    });

    menu.querySelector('[data-action="draft"]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        closeMenu();
        showConfirmModal({
            type: 'confirm',
            message: '下書きに戻します。よろしいですか？',
            confirmText: '下書きに戻す',
            cancelText: 'キャンセル',
            onConfirm: () => {
                draftForm.submit();
            },
        });
    });

    menu.querySelector('[data-action="delete"]')?.addEventListener('click', (e) => {
        e.stopPropagation();
        closeMenu();
        showConfirmModal({
            type: 'confirm',
            message: 'この記事を削除します。この操作は元に戻せません。<br>よろしいですか？',
            confirmText: '削除する',
            cancelText: 'キャンセル',
            onConfirm: () => {
                deleteForm.submit();
            },
        });
    });

    menu.querySelector('[data-action="pickup"]')?.addEventListener('click', async (e) => {
        e.stopPropagation();
        closeMenu();

        const confirmPickup = () => {
            showConfirmModal({
                type: 'confirm',
                message: 'この記事をピックアップに設定します。よろしいですか？',
                confirmText: '設定する',
                cancelText: 'キャンセル',
                onConfirm: () => {
                    pickupForm.submit();
                },
            });
        };

        const confirmUnpickup = () => {
            showConfirmModal({
                type: 'confirm',
                message: 'この記事のピックアップを解除します。よろしいですか？',
                confirmText: '解除する',
                cancelText: 'キャンセル',
                onConfirm: () => {
                    unpickupForm.submit();
                },
            });
        };

        const isPickup = root.dataset.isPickup === '1';
        if (isPickup) {
            confirmUnpickup();
            return;
        }

        try {
            const response = await fetch(PICKUP_COUNT_URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                },
            });
            const data = await response.json();

            if (data.count >= 4) {
                showConfirmModal({
                    message: '<strong>上限数に達しました</strong><br>この投稿をピックアップに設定しますか？',
                    confirmMessage: 'ピックアップに設定できる投稿は4件までです。<br>この投稿をピックアップに設定すると最も前にピックアップに設定された投稿と置き換えられます。',
                    confirmText: '承認',
                    cancelText: 'キャンセルして閉じる',
                    overlayClose: false,
                    onConfirm: () => {
                        pickupForm.submit();
                    },
                });
                return;
            }
        } catch (err) {
            // カウント取得に失敗しても設定処理自体は継続させる。
            console.error(err);
        }

        confirmPickup();
    });
};

const main = () => {
    if (!document.querySelector('#page-magazine-show')) return;
    setMenuAction();
};

export default main;